import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { Label, Tab, TabItem } from 'mw-style-react';
import useIntl from 'useIntl';
import {
  GET_CHILD_TRANSACTIONS,
  GET_SINGLE_TRANSACTION,
} from '@control-front-end/common/constants/actorAccounts';
import AppUtils from '@control-front-end/utils/utils';
import LinkedTransactions from './LinkedTransactions';
import Details from './Details';
import mes from './intl';
import './TrsDetails.scss';

function TrsDetails(props) {
  const {
    ref,
    transaction,
    currencyName,
    is2Step,
    getStatusIcon,
    tableHead,
    renderTransactionRow,
    onClose,
  } = props;
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState('details');
  const [childTransactions, setChildTransactions] = useState([]);
  const [parentTransactions, setParentTransaction] = useState([]);
  const t = useIntl();

  const getChildrenTrs = () => {
    dispatch({
      type: GET_CHILD_TRANSACTIONS.REQUEST,
      payload: { transactionId: transaction.id },
      callback: (data) => {
        setChildTransactions(data);
      },
    });
  };

  const getParentTrs = () => {
    if (!transaction.parentId) return;
    dispatch({
      type: GET_SINGLE_TRANSACTION.REQUEST,
      payload: { transactionId: transaction.parentId },
      callback: (data) => {
        setParentTransaction([data]);
      },
    });
  };

  useEffect(() => {
    getChildrenTrs();
    getParentTrs();
  }, []);

  const renderContent = () => {
    switch (activeTab) {
      case 'childrenTrs':
        return (
          <LinkedTransactions
            transactions={childTransactions}
            currencyName={currencyName}
            getStatusIcon={getStatusIcon}
            tableHead={tableHead}
            renderTransactionRow={renderTransactionRow}
            is2Step={is2Step}
          />
        );
      case 'parentTrs':
        return (
          <LinkedTransactions
            transactions={parentTransactions}
            currencyName={currencyName}
            getStatusIcon={getStatusIcon}
            tableHead={tableHead}
            renderTransactionRow={renderTransactionRow}
            is2Step={is2Step}
          />
        );
      case 'details':
        return <Details transaction={transaction} />;
      default:
        return null;
    }
  };

  const renderMainTrs = () => (
    <div styleName="trs">
      {tableHead()}
      {renderTransactionRow(transaction, false, false)}
    </div>
  );

  return (
    <div styleName="popup__bg" ref={ref}>
      <div styleName="popup">
        <div styleName="popup__header">
          <div styleName="popup__header__btn" onClick={onClose}>
            {t(mes.back)}
          </div>
          <div styleName="popup__header__title">
            <Label
              value={t(mes.transactionDetails)}
              fontSize="large"
              fontWeight="semibold"
            />
          </div>
        </div>
        <div styleName="popup__content">
          <div styleName="popup__content__id">
            <div>
              <span>{t(mes.trsId)}:</span> {transaction.id}
            </div>
            {transaction.ref ? (
              <div>
                <span>{t(mes.trsRef)}:</span> {transaction.ref}
              </div>
            ) : null}
            {transaction.accountAmount ? (
              <>
                <div>
                  <span>{t(mes.availableAmount)}:</span>{' '}
                  {transaction.accountAmount - transaction.accountHoldAmount}{' '}
                  {currencyName}
                </div>
                <div>
                  <span>{t(mes.accountAmount)}:</span>{' '}
                  {transaction.accountAmount} {currencyName}
                </div>
              </>
            ) : null}
            {transaction.accountHoldAmount ? (
              <div>
                <span>{t(mes.accountHoldAmount)}:</span>{' '}
                {transaction.accountHoldAmount} {currencyName}
              </div>
            ) : null}
            {!AppUtils.isUndefined(transaction.accountMinLimit) ? (
              <div>
                <span>{t(mes.minLimit)}:</span> {transaction.accountMinLimit}{' '}
                {currencyName}
              </div>
            ) : null}
            {!AppUtils.isUndefined(transaction.accountMaxLimit) ? (
              <div>
                <span>{t(mes.maxLimit)}:</span> {transaction.accountMaxLimit}{' '}
                {currencyName}
              </div>
            ) : null}
          </div>
          {renderMainTrs()}
          <Tab
            type="auto"
            value={activeTab}
            onChange={({ value }) => setActiveTab(value)}
            underline={true}
          >
            <TabItem label={t(mes.transactionDetails)} value="details" />
            <TabItem
              label={`${t(mes.childTrs)} (${childTransactions.length})`}
              value="childrenTrs"
            />
            <TabItem
              label={`${t(mes.parentTrs)} (${parentTransactions.length})`}
              value="parentTrs"
            />
          </Tab>
          {renderContent()}
        </div>
      </div>
    </div>
  );
}

TrsDetails.propTypes = {
  transaction: PropTypes.object,
  currencyName: PropTypes.string,
  getStatusIcon: PropTypes.func,
  is2Step: PropTypes.bool,
  onClose: PropTypes.func,
};

export default TrsDetails;
